import { FONT } from "@/styles/common";
import { Flex } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { Button } from "../button";

export const CustomFlex = styled(Flex)`
    color: white;
    background: ${({ theme }) => theme.COLOR.text[600]};
    box-sizing: border-box;
    justify-content: space-between;
    ${FONT("pretendard", 14, 300)}
`;

export const CustomButton = styled(Button)`
    color: white;
    width: auto;
    height: auto;
    padding: 0;
    box-sizing: border-box;
    border: none;
`;

export const CloseButton = styled(Button)`
    position: absolute;
    box-sizing: border-box;
    width: 16px;
    height: 32px;
    color: white;
    background: ${({ theme }) => theme.COLOR.text[600]};
    top: 8px;
    right: 8px;
`;
